import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Quote, QuoteLine, CustomerVehicleDetails, sbFleetAuthData, Payment } from '../classes/quote';
import { PosService } from './pos.service';
import { NotificationService } from '../shared/notification.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { PosAuditService } from './posaudit.service';
import { BookingSlot, PosAuditEntry, PosAuditEntryType, StockSearchResult } from '../models/pos';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { differenceInCalendarDays } from 'date-fns';
import { AuthService } from '../auth.service';
import { ReportsService } from '../shared/reports.service';
import { DatePipe } from '@angular/common';
import { Salesman } from '../models/user';
import { aautoquote,sfSearch } from '../models/search-obj';
import { SearchService } from '../search/search.service';
import { LeadsService } from '../leads/leads.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { resultType } from '../shared/modal-content/modal-content.component';
import { SalesmanFleetAuthComponent } from '../fleet/auth/salesman-fleet-auth/salesman-fleet-auth.component';
import { SelectedCustomer } from '../models/customer';
import { CustomerService } from '../customers/customer.service';
import { PhonecallService } from '../shared/phonecall.service';
import { StockPickedItem } from '../models/leads';
import { WebsocketsService } from '../shared/websockets.service';
import { StockModelsService_Replenishment } from '../stock-models/stock-models.service';
import { stockCost } from '../models/stock';

@Component({
  selector: 'app-pos',
  templateUrl: './pos.component.html',
  styleUrls: ['./pos.component.less']
})
export class PosComponent implements OnInit, OnDestroy {

  @ViewChild(SalesmanFleetAuthComponent, { static: false }) fleetAuthComponent!: SalesmanFleetAuthComponent;


  paramsSub: Subscription;
  qparamsSub: Subscription;
  

  quote: Quote = new Quote();
  isLoading = false;
  salesmen: Salesman[] = [];
  assignedSalesman: number = 0;
  backToCustomerId: number = 0;
  leadSelect: number = 0;
  followUpSelect: number = 0;
  reActivate: boolean = false;
  isPickable: boolean = false;
  isSafeGoModalVisible: boolean = false;
  isCustomerReleaseModalVisible: boolean = false;
  showSafeRelease: boolean = true;
  safeGoPin: number | null = null;
  orderId: number;

  navPathAway: string = ""; //used to indicate that the user clicked to navigate away from the page, this will store the intended route.
  isNavModalVisible = false;
  isNavAwayVisible = false;

  isOrderTypeModalVisible = false;

  private quoteSub: Subscription;
  private fleetPosUpdateSub: Subscription;

  constructor(
    private posService: PosService, 
    private notification: NotificationService, 
    private route: ActivatedRoute, 
    private auditService: PosAuditService,
    private router: Router,
    public authService: AuthService,
    private reportsService: ReportsService,
    private searchService: SearchService,
    private leadsService: LeadsService,
    private customerService: CustomerService,
    private phonecallService: PhonecallService,
    private websocketService: WebsocketsService,
    private stockModelsReplenishmentService: StockModelsService_Replenishment) { }

  get quoteActionWebsiteBrand(): 'Tyremart' | 'Tyreworx' {
    return this.authService.user?.licenseId === 4 ? 'Tyreworx' : 'Tyremart';
  }

  get quoteActionWebsiteUrl(): string | null {
    if (!this.quote.quoteActionValue) {
      return null;
    }
    return `https://${this.quoteActionWebsiteBrand.toLowerCase()}.co.za/tyre-size/${this.quote.quoteActionValue}`;
  }

  ngOnDestroy(): void {
    this.quote.quoteToBeSaved$?.unsubscribe();
    this.quote.actionLogToBeSaved$?.unsubscribe();
    this.paramsSub.unsubscribe();
    this.qparamsSub.unsubscribe();
    this.fleetPosUpdateSub?.unsubscribe();
  }

  loadQuote(quoteId: number) {
    // this.isLoading = true;
      this.posService.getQuote(quoteId).subscribe(
        {next: val => {
          //Because Javascript is not staticly typed, we need to specifically cast the return value to the class so we have access to the class methods
          this.quote = Object.assign(new Quote(), val);
          //this.quote.fleetType = this.searchService.lastSelectedSpecialPriceSet ? this.searchService.lastSelectedSpecialPriceSet.authType : 0; //Assign the auth type to the fleet type of the quote.
          
          let newLines: QuoteLine[] = [];
          this.quote.lines.forEach(e => newLines.push(Object.assign(new QuoteLine() , e)));
          newLines.forEach(e => e.updateLineItemGPList(this.quote.vatRate));
          newLines.forEach(e => e.retailValueLess = e.retail); //update retailvalueless for each line item to retail less 0%
          this.quote.lines = newLines;
          this.quote.sortLines();
         
          // this.checkAllOptionsForDiscounts(); This will remove discounts on quotes when you view them, so this is a fairly bad idea. (Only if the discount rule is still active)
          // if (this.quote.canSave === false) {
          // if(this.quote.lines.some(line => line.gpPercent < this.quote.gpProtectionPercent!)){
          //   this.quote.markDirty();
          // }
            
          //all classes mapped successfully
          //If we were busy working with a customer, remove the link. This might need to be changed in the future.
          this.customerService.selectedCustomer = new SelectedCustomer();

          //subscribe to the event if quote needs to be saved
          this.quote.quoteToBeSaved$?.subscribe(
            (val) => {
              this.saveQuote(val);
              
              
            }
          );  
          //sub to event for action log
          this.quote.actionLogToBeSaved$?.subscribe(
            _ => {
              this.saveActionLog();
            }
          );
          //subscribe to requoteWithSpecialPriceSet event
          this.quote.requoteWithSpecialPriceSet$?.subscribe(
            (val) => {
              this.onRequoteClick(true, val);
            }
          );
          this.isLoading = false;

          //Check if Admin and display the dropdown for slameman
          this.assignedSalesman = this.quote.userId;
          if(this.authService.hasClaims(['SDRP']))
          {
            this.posService.getSalesman(this.authService.user.client_id,this.authService.user.user_id).subscribe({next: res => { this.salesmen = res;},error: error => this.notification.handleError(error)});
          }   

          //Check Navaway
          if(this.quote.showNavAway == false)
          {
            this.skipNavAway = true;
          }

          if (this.customerService.pendingCallId && this.quote.custId > 0) {
            this.phonecallService.assignDetailsToCall(this.customerService.pendingCallId, this.quote.custId, quoteId).subscribe();
            this.customerService.pendingCallId = null;
          }

          // Check Online Lead
          // While we only have one online classification, we are removing the unnecessary variable. 
          // This will be updated in the future when we have more than one classification that is readonly - and will be moved to a function.
          // if(this.quote.selectedChannel == 3)
          // {
          //     this.readonlyChannel = true;
          // }
          if (sessionStorage.getItem('isFleetAuthModalVisible') === 'true') {
            this.isFleetAuthModalVisible = true;
            sessionStorage.removeItem('isFleetAuthModalVisible');
          }
        },
        error: err => this.notification.handleError(err)}
      )
  }

  ngOnInit(): void {
    this.fleetPosUpdateSub = this.websocketService.fleetPosUpdated.subscribe(quoteId => {
      if (quoteId === this.quote.quoteId) {
        sessionStorage.setItem('isFleetAuthModalVisible', 'true');
        this.loadQuote(quoteId);
      }
    });
    this.paramsSub = this.route.params.subscribe(params => {
      this.isLoading = true;
      this.loadQuote(+params['quoteid'])
    });
    this.qparamsSub = this.route.queryParams.subscribe( qp => {
      this.backToCustomerId = qp.cid; 
    })
  }

  navigateBackToCustomer() {
    this.router.navigate(['/customer', this.backToCustomerId]);
  }

  addItemsToQuote(items: QuoteLine[]) {
    for (var item of items) {
      if (this.quote.lines.find(e => (e.msfid === item.msfid && item.isTyre && !item.stockUsedId) || (e.customStockId && item.customStockId && e.customStockId == item.customStockId && (this.quote.selectedOption == null || e.optionId == this.quote.selectedOption || e.optionId == null)) || (e.stockUsedId && item.stockUsedId && e.stockUsedId === item.stockUsedId))) {
        //this will ensure that we don't add one item multiple times.
        this.notification.showWarning(`${item.description} already on quote`);
        continue;
      }

      //add audot action first
      const comment = item.qty.toString() + "x " + item.description
      this.auditService.addAction(new PosAuditEntry(this.quote.quoteId, PosAuditEntryType.AddItem, item.msfid, comment))
      //update the gp list
      item.updateLineItemGPList(this.quote.vatRate);

      //check option id
      if (item.isTyre) {
        if (this.quote.selectedOption) {
          item.optionId = this.quote.selectedOption;
        }
        else {
          item.optionId = this.quote.lines.reduce((acc, nxt) => {return nxt.optionId! > acc ? nxt.optionId! : acc},0) + 1;
        }
      } 
      else {
        if (this.quote.selectedOption) {
          item.optionId = this.quote.selectedOption;
        }
      }
      
      this.quote.lines.push(item);

   }
   this.quote.lines = this.quote.lines.slice(); //Force angular change detection
   this.quote.sortLines();
   this.quote.markDirty();
    
  }

  // private checkLineItemForDiscountsDEPRECATED(item: QuoteLine) {    
  //   // for (var discount of this.quote.discountRules) {
  //   //   if ((!discount.BrandDescriptions || discount.BrandDescriptions.split(",").includes(item.brand!)) 
  //   //     && (!discount.MsfidRequirements || discount.MsfidRequirements.split(",").includes(item.msfid.toString()))
        
  //   //     ) {          
  //   //       if (discount.discounts) {
  //   //         for (var discountItem of discount.discounts) {
  //   //           discountItem.optionId = item.optionId;
  //   //           this.quote.lines.push(discountItem);
  //   //         }
  //   //       }
  //   //   } 
  //   // }
  //   console.log("Skipping item line check");
    
  // }

  private checkAllOptionsForDiscounts() {
    //console.log("Should we apply discounts? " + this.quote.shouldApplyDiscounts);
    //console.log(this.quote);
    //check if the customer group is part og the c
    //console.log(this.quote.customerGroups.filter(group => this.quote.custCustomerGroupIds.includes(group.customerGroupId)).map(e => e.specialPriceSetId).includes(this.quote.specialPriceSetId));
    //console.log(this.quote.customerGroups.filter(group => group.specialPriceSetId === this.quote.specialPriceSetId).map(e => e.customerGroupId));
    const customerGroupsThatIsAllowedDiscountRules = this.quote.customerGroups.filter(group => group.specialPriceSetId === this.quote.specialPriceSetId).map(e => e.customerGroupId)
    // Early Exit || !this.quote.canApplyDiscountEngine
    if (!this.quote.shouldApplyDiscounts) {
      return;
    }

    let groupByAndSum = (array, groupKeys, sumKey = 'qty') => {
      const result = array.reduce((acc, item) => {
        // Create composite key from grouping keys
        const key = groupKeys.map(k => item[k]).join('|');
        
        if (!acc[key]) {
          // Create new object with same structure, initialize sum key
          acc[key] = { ...item };
          acc[key][sumKey] = 0;
        }
        
        // Aggregate the quantity
        acc[key][sumKey] += item[sumKey];
        
        return acc;
      }, {});
      
      return Object.values(result);
    }

    // Group all quote lines that have tyres
    let quoteLines = groupByAndSum(this.quote.lines.filter(val => val.isTyre === true).map(item => ({
      ...item, rim: Number(item.rim),
      hasAppliedDiscount: this.quote.discountRules.map(discount => {
          if((!discount.BrandDescriptions || discount.BrandDescriptions?.split(",").includes(item.brand))
          && (!discount.MsfidRequirements || discount.MsfidRequirements?.split(",").includes(item.msfid.toString()))
          && (!discount.tyreQty || discount.tyreQty?.split(",").includes(item.qty.toString()))
          && (!discount.rimSize || discount.rimSize?.split(",").includes((item.rim*1).toString()))
          && (!discount.markets || discount.markets?.split(",").includes(item.market.toString()))
        ) return discount.discountRuleId; else return null }).filter(Number)
    })), ['hasAppliedDiscount', 'optionId']) as any[];

    // Removes all discounts before checking which ones to add
    for (var row of this.quote.lines) {
      for (var discount of this.quote.discountRules.filter(e => e.discounts)) { 
        for (var discountItem of discount.discounts!) {
          this.quote.lines = this.quote.lines.filter(e => !(e.msfid === discountItem.msfid && e.optionId === row.optionId));
        }
      }
    } 
    
    for (var item of quoteLines) {
      for (var discount of this.quote.discountRules.filter(e => e.discounts)) {

        if (
          // item.hasAppliedDiscount.includes(discount.discountRuleId)
          (!discount.BrandDescriptions || discount.BrandDescriptions.split(",").includes(item.brand!)) 
         && (!discount.MsfidRequirements || discount.MsfidRequirements.split(",").includes(item.msfid.toString()))
         && (!discount.tyreQty || discount.tyreQty.split(",").includes(item.qty.toString()))
         && (!discount.rimSize || discount.rimSize.split(",").includes((item.rim*1).toString()))
         && (!discount.markets || discount.markets.split(",").includes(item.market.toString()))
         && this.quote.shouldApplyDiscounts ) {
          
          //needs the discount to be applied
          for (var discountItem of discount.discounts!) {
            if (this.quote.lines.find(e => e.msfid === discountItem.msfid && e.optionId === item.optionId && discountItem.isCriteriaSatisfied === false)) {
              //item needs to be removed
              this.quote.lines = this.quote.lines.filter(e => !(e.msfid === discountItem.msfid && e.optionId === item.optionId));
            }
            else 
            if (quoteLines.find(e => e.msfid === discountItem.msfid && e.optionId === item.optionId && discountItem.isCriteriaSatisfied === true)) {
              //item already has the discount, do nothing
            }
            else if (discountItem.isCriteriaSatisfied === false) {
              //early exit to avoid the following logic to save time
            }
            else {
              //item needs to be added
              let shouldLoadDiscount = true;
              if (!this.quote.canApplyDiscountEngine) {
                //if there is a special price set, we should not load the discount
                shouldLoadDiscount = false;
              }
              //check for customer limitations            
              if (discount.hasCustomerLimits) {
                
                shouldLoadDiscount = false;
                
                if (this.quote.hasCustomer && 
                    this.quote.custCustomerGroupIds.some(i => discount.customerGroupIds.includes(i)) && 
                    (this.quote.canApplyDiscountEngine || discount.customerGroupIds.some(e => customerGroupsThatIsAllowedDiscountRules.includes(e))) 
                  ) {
                  shouldLoadDiscount = true;
                }
                //check that the customer community is the reason for this specialpriceset discount to be added
                // if (shouldLoadDiscount && ) {
                //   shouldLoadDiscount = true;  

                // }
                
              }      

              if (shouldLoadDiscount && discountItem.isCriteriaSatisfied === true) {  
                let itemToBeAdded = Object.assign(new QuoteLine(), discountItem);
                itemToBeAdded.optionId = item.optionId;
                this.quote.lines.push(itemToBeAdded);   
              }
            }
          }

          
        }
        // else {
        //   //needs the discount to be removed.
        //   for (var discountItem of discount.discounts!) {
        //     if (this.quote.lines.find(e => e.msfid === discountItem.msfid && e.optionId === item.optionId && discount.rimSize!.split(",").includes((item.rim * 1).toString()))) {
        //       //remove each item from array
        //   }
        // }
      }
    }
    // this.quote.lines = Array.from(
    //   new Set(this.quote.lines.map(
    //     item => JSON.stringify(item)))).map(
    //       item => JSON.parse(item)); 
  

  }

  private timer: any;
  saveQuote(skipReload: boolean = true) {
    this.checkAllOptionsForDiscounts();
    this.leadsService.updatingLeads.next(true); //Set the leads BehaviourSubject to state that we are updateing a lead.
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      if (this.quote.canSave === false || this.isTyreWithZeroPrice()) {
        return;
      }
      this.quote.isSaving = true;
      this.posService.saveQuote(Object.assign({}, this.quote)).subscribe({
        next: _ => {          
          this.quote.isSaving = false;
          this.quote.isDirty = false;
          this.leadsService.updatingLeads.next(false); //Set the leads BehaviourSubject to state that we are done updating the lead
          this.auditService.saveActions();
          //reload the quote
          if (!skipReload) {
            this.quote.quoteToBeSaved$?.unsubscribe();
            this.quote.actionLogToBeSaved$?.unsubscribe();
            this.quote.requoteWithSpecialPriceSet$?.unsubscribe();
            this.loadQuote(this.quote.quoteId);
          }
          
        },
        error: error => {
          this.quote.isSaving = false;          
          this.leadsService.updatingLeads.next(false); //Set to done udpating
          this.notification.handleError(error);          
        }})
    }, 750);
    
    
  }

  private alTimer: any;
  saveActionLog() {    
    clearTimeout(this.alTimer);
    this.alTimer = setTimeout(() => {
      this.auditService.saveActions();      
    }, 1500);
    
    
  }

  externalVehicleId = 0;
  saveVehicle(vehicle: CustomerVehicleDetails) {
    
    vehicle.odoReading = +vehicle.odoReading; //to make sure an empty string is converted to 0 :)
    
    this.posService.updateVehicleDetails(this.quote.quoteId, vehicle).subscribe({
      next: val => {
        
        
        this.quote.Vehicle_Customer_MappingId = val.Vehicle_Customer_MappingId;
        this.quote.vehicleOdoId = val.vehicleOdoId;
        this.externalVehicleId = val.Vehicle_Customer_MappingId;
      },
      error: err => {
        this.notification.handleError(err);
      }
    })
  }

  changeSalesman(user:number)
  {
    this.quote.userId = this.salesmen.find(x=> x.userId == user)!.userId; 
    this.quote.markDirty(false);


    // this.assignedSalesman = this.salesmen.find(x=> x.userId == user)!.userId; 
    // this.quote.markDirty();
    // this.auditService.addAction(new PosAuditEntry(this.quote.quoteId, PosAuditEntryType.AdminChangeQuoteSaleman, 0, "Admin assigned " + this.salesmen.find(x=> x.userId == user)?.fullname + " with userId " + this.salesmen.find(x=> x.userId == user)?.userId + " to quote: " + this.quote.quoteId));
    // this.posService.updateSalesman(this.quote.quoteId,user).subscribe(
    //   {
    //     next: res => { 
    //       this.assignedSalesman = this.salesmen.find(x=> x.userId == user)!.userId; 
    //       this.notification.showSuccess("Salesman Updated!");
    //       this.saveActionLog();
    //     },
    //     error: error => this.notification.handleError(error)
    //   });
  }


  //#region NAV AWAY GUARD AND MODAL ACTIONS
  skipNavAway = false;
  followUpDate: Date = new Date();
  @ViewChild('followUpDatePicker') followUpDatePicker!: NzDatePickerComponent;
  today = new Date(); //to reuse a date object to check all dates, in stead of creating a new one for evey day to check
  // Can not select days before today, but not today
  disabledDate = (current: Date): boolean => differenceInCalendarDays(current, this.today) < 0;
  statusComment = "";
  PosAuditEntryType = PosAuditEntryType;

  checkNavGuard(navPathAway: string): boolean {
    
    // if (!this.quoteDirty && this.statusSaved) {
    //   return true;
    // }
    if (this.skipNavAway || this.quote.custId == 14041 || this.quote.custId == 0) { 
      return true;
    }
    if (!this.navPathAway && !this.quote.isWIP) {
      this.showStatusModal(true)
      this.navPathAway = navPathAway;
      return false;
    } else if (this.navPathAway === navPathAway) {
      return true;
    }
    else {
      //What to do now? Navigating to a different path?
      return true;
    }

  }

  showStatusModal(isNavAwayVisible: boolean){
    this.isNavModalVisible = true;
    this.isNavAwayVisible = isNavAwayVisible;
    //this.followUpDate = new Date();
  }

  navigateWithoutSaving () {
    this.router.navigate([this.navPathAway]);
  }

  checkLunchDisabled() : boolean {
    if (new Date().getHours() < 12) {
      return false;
    }
    return true;
  }

  followUpAddMinutes(num: number) {
    this.followUpDate = new Date(); //reset the date and time, to be 100% sure
    this.followUpDate.setMinutes(this.followUpDate.getMinutes() + num);
    // this.followUpDatePicker.writeValue(this.followUpDate);
    this.updateQuoteStateWithAction(PosAuditEntryType.FollowUpLater);
  }

  followUpAddHours(num: number) {
    this.followUpDate = new Date(); //reset the date and time, to be 100% sure
    this.followUpDate.setHours(this.followUpDate.getHours() + num);
    // this.followUpDatePicker.writeValue(this.followUpDate);
    this.updateQuoteStateWithAction(PosAuditEntryType.FollowUpLater);
  }


  followUpAddDays(num: number) {
    this.followUpDate = new Date(); //reset the date and time, to be 100% sure
    this.followUpDate.setDate(this.followUpDate.getDate() + num);
    this.followUpDate.setHours(0);
    this.followUpDate.setMinutes(0);
    this.followUpDate.setSeconds(0);
    // this.followUpDatePicker.writeValue(this.followUpDate);
    this.updateQuoteStateWithAction(PosAuditEntryType.FollowUpLater);
  }

  followUpLunch() {
    this.followUpDate = new Date(); //reset the date and time, to be 100% sure
    this.followUpDate.setHours(12);
    this.followUpDate.setMinutes(0);
    this.followUpDate.setSeconds(0);
    // this.followUpDatePicker.writeValue(this.followUpDate);
    this.updateQuoteStateWithAction(PosAuditEntryType.FollowUpLater);
  }

  updateQuoteStateWithAction(action: PosAuditEntryType, followUp: boolean = true){
    this.auditService.addAction(new PosAuditEntry(this.quote.quoteId, action, 0, (followUp===true ? this.followUpDate.toLocaleString('en-GB').substring(0,17).replace(", 00:00","") + " :: " : "") + (this.statusComment.length > 0 ? this.statusComment : "")));
    
    let statusId: number = 0; //to store the quote status id, based on the action we just took
    switch (action) {
      case PosAuditEntryType.FollowUpLater:{statusId = 6; break;}
      case PosAuditEntryType.PriceChecking:{statusId = 14; break;}
      case PosAuditEntryType.IncorrectCustomerDetails:{statusId = 22; break;}
      case PosAuditEntryType.CustomerUnreachable:{statusId = 10; break;}
      case PosAuditEntryType.BoughtFromCompetitor:{statusId = 23; break;}
      case PosAuditEntryType.ClosedOther:{statusId = 24; break;}
      case PosAuditEntryType.CommitedToBuy:{statusId = 28; break;}
      case PosAuditEntryType.TentativelyAccepted:{statusId = 18; break;}
      case PosAuditEntryType.ReactivateQuote:{statusId = 29; break;} // reactivating a closed quote

      default:
        statusId = 6;
        break;
    }

    if (!followUp) 
    {
      this.updateQuoteStatus(statusId, undefined); 
      
      if((this.quote.leadChannel && this.quote.selectedChannel == null) ||  (this.quote.leadType && this.quote.selectedType == null) || (this.reActivate === true))
      {
        this.reActivate = false;
        return; // dont allow navigation if classifications not met
      }
      if (!this.navPathAway) {
        this.navPathAway = "/search";
      }
    }
    else {
      this.updateQuoteStatus(statusId, this.followUpDate);    
      if((this.quote.leadChannel && this.quote.selectedChannel == null) ||  (this.quote.leadType && this.quote.selectedType == null) || (this.reActivate === true))
      {
        this.reActivate = false;
        return; // dont allow navigation if classifications not met
      }
      this.statusComment = "";
      this.navPathAway = "/search";
    }

    if (this.navPathAway) {     
      if((this.quote.leadChannel && this.quote.selectedChannel == null) ||  (this.quote.leadType && this.quote.selectedType == null))
      {
        return; // dont allow navigation if classifications not met
      }
      this.router.navigate([this.navPathAway])
    }
    this.isNavModalVisible = false;
  }

  private updateQuoteStatus(statusId: number, actionDate?: Date) {

    if (actionDate){
      this.quote.dt_act = actionDate;
    }
    this.quote.quoteStatusId = statusId;
    this.quote.markDirty()
  }

  followUpChange($event:any)
  {
    this.followUpSelect = $event;
    if($event == 1) {
      this.followUpAddMinutes(15);
    }
    else if ($event == 2)
    {
      this.followUpAddHours(1);
    }
    else if ($event == 3)
    {
       this.followUpAddHours(2);
    }
    else if ($event == 4)
    {
     this.followUpLunch();
    }
    else if ($event == 5)
    {
      this.followUpAddDays(1);
    }
    else if ($event == 6)
    {
      this.followUpAddDays(2);
    }
  }

  closeLead($event:any){
    this.leadSelect = $event;
    if($event == 1){
      this.updateQuoteStateWithAction(PosAuditEntryType.BoughtFromCompetitor, false)
    }
    else if ($event == 2){
      this.updateQuoteStateWithAction(PosAuditEntryType.CustomerUnreachable, false)
    }
    else if ($event == 3){
       this.updateQuoteStateWithAction(PosAuditEntryType.PriceChecking, false)
    }
    else if ($event == 4){
       this.updateQuoteStateWithAction(PosAuditEntryType.CommitedToBuy, false)
    }

  }

  classifyLead($event:any,classification:number)
  {
    if(classification == 1)
    {
      this.quote.selectedChannel = $event;
    }
    if(classification == 2)
    {
      this.quote.selectedType = $event
    }
    this.quote.markDirty();

    if (this.isLeadClassificationModalVisible) {
      //this means we are classifying the lead, not navigating away. So there is no ACTION necessary, just classification
      this.executeMethodToRunWhenLeadClassified();
      this.isLeadClassificationModalVisible = false;
    }
  }
  
  public methodToRunWhenLeadClassified: (() => void);
  private changeStatusToWhenLeadClassified: number = 0;
  public isLeadClassificationModalVisible = false;

  shouldStopForClassifyModal(methodToRunWhenSelected: () => void): boolean {
    if((this.quote.leadChannel && this.quote.selectedChannel == null) ||  (this.quote.leadType && this.quote.selectedType == null)) {
      this.methodToRunWhenLeadClassified = methodToRunWhenSelected;
      this.isLeadClassificationModalVisible = true;      
    }
    else {
      this.isLeadClassificationModalVisible = false;        
    }
    return this.isLeadClassificationModalVisible;
  }

  executeMethodToRunWhenLeadClassified() {     
    //before changing the quote, run the status change
    if (this.changeStatusToWhenLeadClassified)  {      
      this.quote.quoteStatusId = this.changeStatusToWhenLeadClassified;
      this.changeStatusToWhenLeadClassified = 0;
    }
    //now call the method, which might mark the quote as dirty, updating the status to the above.
    if (this.methodToRunWhenLeadClassified) {
      this.methodToRunWhenLeadClassified();
    }
  }



  //#endregion



//#region Save/WIP/Complete Quote
assignWIP(reserveStock: boolean) {
  // if (!this.isAllQuoteValuesValid()) {
  //   return;
  // }

  // this.isSavingQuote = true;
  //action audit
  if (this.shouldStopForClassifyModal(() => this.assignWIP(reserveStock))) {    
    this.changeStatusToWhenLeadClassified = reserveStock ? 27 : 26;    
    return;
  }

  this.auditService.addAction(new PosAuditEntry(this.quote.quoteId, PosAuditEntryType.WorkInProgress, 0));
  if (reserveStock) {
    this.auditService.addAction(new PosAuditEntry(this.quote.quoteId, PosAuditEntryType.StockReserved, 0));
  }
  this.quote.markActionLog();

  
  this.posService.assignWorkInProgress(this.quote.quoteId, reserveStock, !this.isPickable).subscribe({
    next : _ => {
      this.reportsService.openJobCard(this.quote.quoteId); // Open Jobcard in new window

      this.skipNavAway = true;
      this.router.navigate(['wip']);
    },
    error : error => {
      this.notification.handleError(error);
    }
  });
}

cancelJobCard() {
  this.showStatusModal(false);
}

tentativelyAccept(now: boolean = true) {
  //assign the tentativelyAccept function to methodToRunWhenLeadClassified

  if (this.shouldStopForClassifyModal(() => this.tentativelyAccept(now))) {
    return;
  }
  this.skipNavAway = true;
  this.navPathAway = "/leads"; //to navigate away after accepting
  if (now) {this.followUpDate = new Date();} //To make the follow up now
  this.updateQuoteStateWithAction(PosAuditEntryType.TentativelyAccepted, true);
}

completeSale() {
  //do validation checking of valid values
  // if (!this.isAllQuoteValuesValid()) {
  //   return;
  // }
  // this.isSavingQuote = true;
  //action audit
  if (this.shouldStopForClassifyModal( () => this.completeSale() )) {
    this.changeStatusToWhenLeadClassified = 11; //to set the status to completed if classify is done
    return;
  }

  this.auditService.addAction(new PosAuditEntry(this.quote.quoteId, PosAuditEntryType.SaleCompleted, 0));
  this.quote.markActionLog();

  this.quote.isDirty = true;
  this.posService.completeSale(this.quote).subscribe(
    val => {
      if (this.authService.user.featureLevel >= 3) {
        this.reportsService.openInvoice(val["saleId"]);
      }
      this.quote.isDirty = false;
      // this.modalService.create({
      //   nzTitle: 'Success',
      //   nzContent: 'Sale was successfully created. Please allow a few minutes for the sale to be inserted in your POS.',
      //   nzFooter: null
      // });
      //this.notification.ShowBlockingPopup("Sale was successfully created. Please allow a few minutes for the sale to be inserted in your POS.")
      if (this.authService.user.isPremium) {
        this.notification.showSuccessPinned("Sale was successfully created. Please allow a few minutes for the sale to be inserted in your POS.");
      }
      else {
        this.notification.showSuccessPinned("Sale was successfully created.");
      }
      this.quote.isDirty = false;
      if (this.authService.user.hasSafeGo && this.authService.checkMenu(['SFG'])) {
        this.orderId = val["saleId"];
        this.isCustomerReleaseModalVisible = true;
      }
      else{
        this.skipNavAway = true;
        this.router.navigate(["sales"]);
        sessionStorage.clear();
        localStorage.removeItem('required');

      }
    },
    error => {

      this.notification.handleError(error);
      this.quote.isDirty = false;
    }
  )
   

}

  navToSalesPage() {
    this.skipNavAway = true;
    this.router.navigate(["sales"]);
    sessionStorage.clear();
    localStorage.removeItem('required');
  }

  sendSafeGoWhatsApp(sendNow: boolean = true) {
    this.posService.sendSafeGoWhatsApp(this.orderId).subscribe({
      next: res => {
        this.notification.showSuccess("SafeGo WhatsApp sent successfully.");
        this.skipNavAway = true;
        this.router.navigate(["sales"]);
        sessionStorage.clear();
        localStorage.removeItem('required');
      },
      error: err => {
        this.notification.handleError(err);
      }
    })
  }

  // verifySafeGo(safeGoPin){
  //   this.posService.verifySafeGo(this.quote.quoteId, safeGoPin).subscribe({
  //     next: res => {
  //       this.notification.showSuccess("SafeGo verified successfully.");
  //       this.isSafeGoModalVisible = false;
  //       this.skipNavAway = true;
  //       this.router.navigate(["sales"]);
  //       sessionStorage.clear();
  //       localStorage.removeItem('required');
  //     },
  //     error: err => {
  //       this.notification.showError(err);
  //     }
  //   })
  // }

quoteTotalIncVat = 0;
paymentsTotal = 0;

isInvoiceModalVisible = false;

saleModal() {

  this.quoteTotalIncVat = this.quote.lines
  .reduce((a,b) => {return a + b.totalPriceIncl;},0);

  this.isInvoiceModalVisible = true;
  this.quote.payments  = [
    {
      amount: this.quoteTotalIncVat,
      paymentTypeId: 1
    },
    {
      amount: 0,
      paymentTypeId: 0
    }
  ];

}

isPaymentsEqual(){
  return (this.quoteTotalIncVat === this.quote.payments[0].amount + this.quote.payments[1].amount);
}
updatePaymentAmount(index: number) {
  if (index === 0) {
    this.quote.payments[0].amount = Math.min(this.quote.payments[0].amount, this.quoteTotalIncVat);
    this.quote.payments[1].amount = this.quoteTotalIncVat - this.quote.payments[0].amount;
  } else {
    this.quote.payments[1].amount = Math.min(this.quote.payments[1].amount, this.quoteTotalIncVat);
    this.quote.payments[0].amount = this.quoteTotalIncVat - this.quote.payments[1].amount;
  }
  this.quote.payments[0].amount = Math.round(this.quote.payments[0].amount * 100) / 100;
  this.quote.payments[1].amount = Math.round(this.quote.payments[1].amount * 100) / 100;
  this.paymentsTotal = this.quote.payments[0].amount + this.quote.payments[1].amount;
  this.paymentsTotal = Math.round(this.paymentsTotal * 100) / 100;
}


submitInvoice() {

  if (!this.isPaymentsEqual()) {
    this.notification.showError("Payments do not match the total amount.");
    return;
  }
  this.quote.payments = this.quote.payments.filter(payment => payment.amount > 0);
  this.completeSale()
  this.isInvoiceModalVisible = false;
}


checkCanClickComplete() : boolean {
  return this.quote.hasCustomer && !this.isTyreWithZeroPrice();
} 

getCompleteButtonTooltip() : string {
  return !this.quote.hasCustomer ? 'Select Customer Details First!' : this.quote.booking ? 'BOOKED: ' + this.quote.booking.dateBooked + ' ' + this.quote.booking.timeBooked : this.isTyreWithZeroPrice() ? 'Cannot have retail of R0' : '';
}

private isTyreWithZeroPrice() : boolean {
  return this.quote.lines.some(e => e.isTyre && (e.priceIncl === 0 || e.price === 0));
}

//#endregion


onRequoteClick(quoteOnSameId: boolean = false, overrideSpecialPriceSetId: number = 0) {

    this.skipNavAway = true;
    this.isLoading = true;
    let search: string = 'NOSEARCH'
    if(this.quote.width && this.quote.profile && this.quote.rim) {
      search = (this.quote.width*1).toString() + (this.quote.profile*1).toString() + (this.quote.rim*1).toString();
    }
    
    let msfidsTyres = this.quote.lines.filter(e => e.isTyre === true).map(e => e.msfid);
    //check for non tyres, that has a customStockId and that is NOT a discount, according to current discount rules.
    let customStockIds = this.quote.lines.filter(e => e.isTyre === false && e.customStockId && !this.quote.discountRules.some(a => a.discounts![0].msfid === e.msfid)).map(e => e.customStockId);
    
    //console.log(this.quote.lines.filter(e => e.isTyre === false && e.customStockId && !this.quote.discountRules.some(a => a.discounts![0].msfid === e.msfid)).map(e => e.customStockId));
    
    
    let vreg = ""; //add vreg?
    
    // //remove any discount rules that are on the current quote, so that we don't add them to the new quote.
    // for (var discount of this.quote.discountRules.filter(e => e.discounts)) {
    //   //needs the discount to be removed.
    //   if (this.quote.lines.find(e => e.msfid === discount.discounts![0].msfid )) {
    //     //remove item from array
    //     this.quote.lines = this.quote.lines.filter(e => !(e.msfid === discount.discounts![0].msfid));
    //   }
    // }

    let quote : aautoquote = {
      sellerId : this.authService.user.client_id,
      ext_Ref : "",
      comment :"",
      name: this.quote.custName,
      cell: this.quote.custCell,
      email: this.quote.custEmail,
      vreg: vreg,
      vatNumber: this.quote.custVATNumber,
      assignedToUserId: this.authService.user.user_id,
      lastcall: parseInt(localStorage.getItem('lastcall')!),
      quote_logic : {
                      search_requirements :
                                            {
                                              raw_search: search,
                                              stock_msfids: msfidsTyres,
                                              none_stock_msfids: [],
                                              custom_stock_ids: customStockIds,
                                              buyerId: this.authService.user.client_id,
                                              specialPriceSetId: overrideSpecialPriceSetId ? overrideSpecialPriceSetId : this.quote.specialPriceSetId
                                            },
                      add_lead: true,
                      qty: 4,
                      allow_partial_full:true,
                      base_level_limit: "Remote",
                      add_recommended_stock: false,
                      max_recommended_options: 3,
                      recommended_level_limit: "Remote",
                      add_default_services: false,
                      isContractPricing: false
                    }
    };

    if (quoteOnSameId) {
      quote.quoteId = this.quote.quoteId;
    }
  

    this.searchService.Autoquote(quote, {customerId : this.quote.custId, vehicleId : this.quote.Vehicle_Customer_MappingId}).subscribe({
      next: res => {
         this.isLoading = false;
         var quoteId = res["quoteId"];
         if (quoteId != 0 && !quoteOnSameId) {
            this.isLoading = false;
            this.notification.showSuccess('Quote Created');
            this.router.navigate(["/pos/v2",quoteId])
         }
         if (quoteId) {
          this.loadQuote(quoteId);
         }
      },
      error: error => {
        this.isLoading = false;
        this.notification.handleError(error);
      }
    });
  
}

onReactivateClick(){
  this.reActivate = true;
  this.quote.stateId = 1;
  this.quote.quoteStatusId = 29; //reactivate status id
  this.updateQuoteStateWithAction(PosAuditEntryType.ReactivateQuote);
}


//#region BOOKINGS
      
  bookingSlots: BookingSlot[] = [];
  bookingSelectedDate: string = "";
  datePipe: DatePipe = new DatePipe(this.posService.locale);
  isBookingModalVisible = false;
  isLoadingBookingSlots = false;

  onBookingClick() {
    if (this.shouldStopForClassifyModal(() => this.onBookingClick())) {
      return;
    }

    this.isBookingModalVisible = true;
    this.loadSlots(new Date());
    this.bookingSelectedDate = this.datePipe.transform(new Date(),'dd MMM')!;
  }

  private loadSlots(date: Date) {
    this.isLoadingBookingSlots = true;
    this.posService.getBookingSlotsPerDay(date).subscribe(
      val => {
        this.bookingSlots = val;
        this.isLoadingBookingSlots = false;
      },
      error => {
        this.notification.handleError(error);
      }
    )
  }

  onBookingDateSelected(val: Date) {
    

    this.bookingSelectedDate = this.datePipe.transform(val,'dd MMM')!;
    this.loadSlots(val);
  }

  onSlotSelected(i: BookingSlot){

    this.followUpDate = new Date(i.date + "T00:00");
    this.auditService.addAction(new PosAuditEntry(this.quote.quoteId, PosAuditEntryType.SalesmanBookedSlot, 0, i.date + " " + i.slotTime));

    this.posService.confirmBooking(this.quote.quoteRef, this.quote.quoteId, i.date, i.slotTime).subscribe(
      val => {
        this.tentativelyAccept(false);
      },
      error => {
        this.notification.handleError(error);
      }
    );
  }
//#endregion


//#region FLEET AUTH

sbauthForm: FormGroup = new FormGroup({
  odometer: new FormControl('', Validators.required),
  drivername: new FormControl('', Validators.required),
  drivercell: new FormControl('', Validators.required),
});

isSbAuthModalVisible = false;
public showSBAuth() {
  const selectedVehicle = this.quote.customerVehicles.find(x =>  x.Vehicle_Customer_MappingId === this.quote.Vehicle_Customer_MappingId);
  if (!selectedVehicle || !selectedVehicle.vehicleMakeId || !selectedVehicle.vehicleModelId || !selectedVehicle.v_reg) {
    this.notification.showError("Please enter vehicle details, make and model and registration, for Standard Bank Fleet Auth");
    return;
  }
  this.isSbAuthModalVisible = true;
}

public onSbAuthSubmit() {
  //valication: TODO: Move to proper form validation
  if(this.sbauthForm.value.odometer == ""  || this.sbauthForm.value.drivercell == "" || this.sbauthForm.value.drivername == "" ) {
     this.notification.ShowAlert({type: resultType.Warning, 
       title: "Incomplete Submission", 
       htmlMessage: 'Please check that all fields are completed before submitting' ,
       maskClosable: false, 
       autoCloseInMilliseconds: 10000});
       return
  }
  const selectedVehicle = this.quote.customerVehicles.find(x =>  x.Vehicle_Customer_MappingId === this.quote.Vehicle_Customer_MappingId);
  if(selectedVehicle === undefined) {
    this.notification.ShowAlert({type: resultType.Warning, 
      title: "Incomplete Submission", 
      htmlMessage: 'Vehicle was not found' ,
      maskClosable: false, 
      autoCloseInMilliseconds: 5000});
      return
  }
  this.isLoading = true;
  this.auditService.addAction(new PosAuditEntry(this.quote.quoteId, PosAuditEntryType.SaleCompleted, 0));
  this.quote.markActionLog();

  //valid form, prep for submission
  this.quote.sbFleetAuthData = new sbFleetAuthData();
  this.quote.sbFleetAuthData.odo = this.sbauthForm.value.odometer;
  this.quote.sbFleetAuthData.driver_name = this.sbauthForm.value.drivername; 
  this.quote.sbFleetAuthData.driver_cell = this.sbauthForm.value.drivercell;
  this.quote.authType = 1; //SB Fleet Auth
  this.quote.isSaving = true;
  this.quote.isDirty = true;
  this.posService.saveQuote(Object.assign({}, this.quote)).subscribe({
    next: _ => {  
      this.posService.completeSale(this.quote).subscribe({next: () => {
        this.quote.isSaving = false;
        this.quote.isDirty = false;
        this.quote.stateId = 3; //lock user from changing any values - 3 = Completed
        this.isSbAuthModalVisible = false;
        this.isLoading = false;
        this.notification.ShowAlert(({type: resultType.Success, title: "Success", htmlMessage: 'Auth Was Successfully Submitted. In a few seconds you will get the result.', maskClosable: false, autoCloseInMilliseconds: 10000}));
        this.skipNavAway = true;
        this.router.navigate(["sales"]);
      },
      error: error => {
        this.quote.isSaving = false;
        this.isLoading = false;
        this.quote.isDirty = false;   
        this.notification.handleError(error);
        this.skipNavAway = true;
        this.router.navigate(["sales"]);
      }})        
        
    },
    error: error => {
      this.quote.isSaving = false;  
      this.isLoading = false;
      this.quote.isDirty = false;        
      this.notification.handleError(error);          
    }})      
      
    

}

isFleetAuthModalVisible = false;


//#endregion

downloadSteps() {
  this.fleetAuthComponent?.downloadProcessDocument();
}

downloadQuote() {
  if (this.fleetAuthComponent) {
    this.fleetAuthComponent.downloadQuote();
  }
}

closeBasicQuote(){
  this.skipNavAway = true;
  this.router.navigate(['search']);
}

// -----------------------------------------------------------------------
// TRUE DEMAND ON STOCK RESERVATION LOGIC
// -----------------------------------------------------------------------
selectedQuoteLines: QuoteLine[] = [];
replenishmentTypeByLine = new Map<QuoteLine, ReplenishmentType>();
replenishmentQuantityByLine = new Map<QuoteLine, number>();
availableTrueDemandSuppliers: StockSearchResult[] = [];
trueDemandSupplierQuantities = new Map<StockSearchResult, number>();

initializeReplenishmentTypes(): void {
  this.selectedQuoteLines.forEach(line => this.replenishmentTypeByLine.set(line, 'replenishment'));
}

toggleQuoteLine(line: QuoteLine, selected: boolean): void {
  if (line.stockReplenishmentId !== 0 && line.msl > 0) {
    return;
  }

  if (selected) {
    if (!this.selectedQuoteLines.includes(line)) {
      this.selectedQuoteLines = [...this.selectedQuoteLines, line];
    }
    return;
  }

  this.selectedQuoteLines = this.selectedQuoteLines.filter(selectedLine => selectedLine !== line);
}

lastLine: QuoteLine = new QuoteLine();
setReplenishmentType(line: QuoteLine, type: ReplenishmentType): void {
  // if (line.stockReplenishmentId !== 0 && line.msl > 0) {
  //   return;
  // }
  this.lastLine = line;
  this.replenishmentTypeByLine.set(line, type);
  this.toggleQuoteLine(line, type === 'replenishment');
  for(let b = 0; b < this.availableTrueDemandSuppliers.length;b++){
    this.setTrueDemandSupplierQuantity(this.availableTrueDemandSuppliers[b],this.requiredQty);
  }
}

get hasTrueDemandSelection(): boolean {
  return this.quote.lines.some(line => this.replenishmentTypeByLine.get(line) === 'trueDemand');
}

getReplenishmentQuantity(line: QuoteLine): number {
  // const quantity = line.qty- line.soh;
  const quantity = this.replenishmentQuantityByLine.get(line);
  if (quantity !== undefined) {
    return quantity;
  }

  return Math.min(Math.max(0, line.qty), Math.max(0, line.soh));
}

setReplenishmentQuantity(line: QuoteLine, quantity: number): void {
  this.replenishmentQuantityByLine.set(
    line,
    // Math.min(Math.max(0, quantity), Math.max(0, line.soh))
    Math.min(Math.max(0, quantity), Math.max(0, line.soh))
  );
}

getTrueDemandQuantity(stockCode: string): number | undefined {
  return this.quote.lines.find(line => line.stockCode === stockCode)?.qty;
}

getTrueDemandSupplierQuantity(supplier: StockSearchResult): number {
  // let availableStock: number = parseInt(String(supplier.soh), 10);
  const quantity = this.trueDemandSupplierQuantities.get(supplier);
  if (quantity !== undefined) {
    return quantity;
  }

  return Math.min(
    Math.max(0, this.getTrueDemandQuantity(supplier.stockCode) ?? 0),
    Math.max(0, this.getAvailableStock(supplier.soh))
  );
}

getAvailableStock(soh: number | string): number {
    return parseInt(String(soh), 10) || 0;
}

setTrueDemandSupplierQuantity(supplier: StockSearchResult, quantity: number): void {
  let availableStock: number = parseInt(String(supplier.soh), 10);
  this.trueDemandSupplierQuantities.set(
    supplier,
    Math.min(Math.max(0, quantity), Math.max(0, availableStock))
  );
}

get trueDemandSupplierOptions(): StockSearchResult[] {
  // const selectedStockCodes = new Set(
  //   this.quote.lines
  //     .filter(line => this.replenishmentTypeByLine.get(line) === 'trueDemand')
  //     .map(line => line.stockCode)
  // );
  // console.table(this.availableTrueDemandSuppliers.filter(option => selectedStockCodes.has(option.stockCode)));
  // console.log('-------')
  // return this.availableTrueDemandSuppliers.filter(option => selectedStockCodes.has(option.stockCode));

  const selectedStockCodes = new Set(
    this.quote.lines
      .filter(line => this.replenishmentTypeByLine.get(line) === 'trueDemand')
      .map(line => line.msfid)
  );
  return this.availableTrueDemandSuppliers.filter(option => selectedStockCodes.has(option.msfid));
}

sourcedSuppliers: number[] = [];
requiredQty: number = 0;
supplierRequiredFields = {}
findPotentialSuppliersOnStockCode(): void {
  this.demandAssignmentLoading = true;
  for (let x = 0; x < this.quote.lines.length; x++) {
    if (this.quote.lines[x].stockTypeId == 1) {
      this.stockModelsReplenishmentService.getGroupReplenishmentStock(this.quote.lines[x].msfid).subscribe(res=>{
        this.quote.lines[x].replenishmentSupplierId = res["replenishmentSupplierId"];
        this.quote.lines[x].replenishmentSupplierName = res["supplier_name"];
        this.quote.lines[x].replenishmentSupplierSoh = res["suppplier_soh"];
        this.quote.lines[x].customerSoh = res["customerSoh"];
        this.quote.lines[x].msl = res["msl"];
        this.requiredQty =  this.quote.lines[x].qty-res["customerSoh"];
        this.replenishmentQuantityByLine.set(
          this.quote.lines[x],
          this.quote.lines[x].qty-res["customerSoh"]
          
      
        );
        if ((this.replenishmentQuantityByLine.get(this.quote.lines[x]) ?? 0) < 0) {
          this.replenishmentQuantityByLine.set(
            this.quote.lines[x],
            (this.quote.lines[x].qty-res["customerSoh"])*-1
          );
        }
        this.demandAssignmentLoading = false;
      })
      const searchObj: sfSearch = {
        search_logic: {
          search_requirements: {
            raw_search: this.quote.lines[x].stockCode,
            specialPriceSetId: this.quote.specialPriceSetId,
            includeUsedStock: false,
            searchType: 1,
          }
        },
        sellerId: this.authService.user.client_id
      };
      this.searchService.searchStock(searchObj).subscribe(res => {
       
        this.supplierRequiredFields = res['required']
        console.log(this.supplierRequiredFields)
        for (let j = 0; j < res['tyres'].length; j++) {
          const tyre = res['tyres'][j];
          if(res['tyres'][j].sellerId != this.quote.clientId && !this.sourcedSuppliers.includes(res['tyres'][j].sellerId)){
            this.availableTrueDemandSuppliers.push(
              Object.assign(new StockSearchResult(), tyre, {
                stockCode: tyre.stock_code,
                supplier: tyre.seller_name,
                price: tyre.buy_price
              })
            );
            this.sourcedSuppliers.push(res['tyres'][j].sellerId);
            
          }
        }

        this.availableTrueDemandSuppliers = this.availableTrueDemandSuppliers.slice();
        
        // for(let b = 0; b < this.availableTrueDemandSuppliers.length;b++){
        //   this.setTrueDemandSupplierQuantity(this.availableTrueDemandSuppliers[b],this.requiredQty);
        // }
        // this.demandAssignmentLoading = false;
      });
    }
  }
}

trueDemandOrderComment = ""


requiredOrderRef = "";
requiredMake = "";
requiredMileage = 0;
requiredSalesman = "";
requiredVReg = "";
requiredDelivery = false;
requiredDeliveryAddress = "";

showRequirementInputs = false;
supplierRequirements = {}
checkoutLine: StockSearchResult = new StockSearchResult();
checkSupplierRequirements(line:StockSearchResult):void{
  console.log(this.quote)
  this.checkoutLine = line;
  this.supplierRequirements = this.supplierRequiredFields['s'+line.sellerId]
  console.log(this.supplierRequirements)
  // check vehicle mapping if one exists -----------
  if(this.quote.Vehicle_Customer_MappingId){
    for(let x = 0; x<this.quote.customerVehicles.length;x++){
      if(this.quote.customerVehicles[x].Vehicle_Customer_MappingId == this.quote.Vehicle_Customer_MappingId){
        if(this.requiredVReg == ""){
          this.requiredVReg = this.quote.customerVehicles[x].v_reg;
        }
        if(this.requiredMake == ""){
          this.requiredMake = this.quote.customerVehicles[x].vehicleMake;
        }
        if(this.requiredMileage == 0){
          this.requiredMileage = this.quote.customerVehicles[x].odoReading;
        }
      }
    }
   
  }
  this.requiredSalesman = this.quote.userFullname;
  if(this.supplierRequirements['delivery'] == 1){
    this.requiredDelivery = true;
  }
  if(this.supplierRequirements['ext_ref'] == 1 && this.requiredOrderRef == ""){
    this.notification.showWarning("Order reference required");
    this.showRequirementInputs = true;
  }
  else if(this.supplierRequirements['reg'] == 1 && this.requiredVReg == ""){
    this.notification.showWarning("Vehicle registration required");
    this.showRequirementInputs = true;
  }
  else if(this.supplierRequirements['make'] == 1 && this.requiredMake == ""){
    this.notification.showWarning("Vehicle make required");
    this.showRequirementInputs = true;
  }
  else if(this.supplierRequirements['milage'] == 1 && this.requiredMileage == 0){
    this.notification.showWarning("Vehicle mileage required");
    this.showRequirementInputs = true;
  }
  else if(this.supplierRequirements['salesman'] == 1 && this.requiredSalesman == ""){
    this.notification.showWarning("Salesman required");
    this.showRequirementInputs = true;
  }
  else if(this.supplierRequirements['delivery'] == 1 && this.requiredDeliveryAddress == ""){
    this.requiredDelivery = true;
    this.notification.showWarning("Delivery address required");
    this.showRequirementInputs = true;
  }
  else{
    this.trueDemandCheckOut(line);
  }

  
  
}

trueDemandCheckOut(line: StockSearchResult): void {
  var Order = {
    "OrderDetails":[
      {
        "brand": line.brand,
        "code": line.stockCode,
        "description": line.description,
        "id": "id"+line.stockCode,
        "image": line.brandLogoUrl,
        "mass": 0,
        "minOrder": 0,
        "minOrderFee": 0,
        "msfid":line.msfid,
        "price":line.price,
        "qty": this.trueDemandSupplierQuantities.get(line),
        "selectedIndex":1,
        "seller":line.supplier,
        "sellerId": line.sellerId,
        "sla":line.sla,
        "soh": this.getAvailableStock(line.soh),
        "sohInt": this.getAvailableStock(line.soh),
        "stockUsedId": null
      }
    ],
    "Settings":{
      "Delivery":this.requiredDeliveryAddress,
      "Extref":this.requiredOrderRef,
      "Make":this.requiredMake,
      "Milage":this.requiredMileage,
      "Salesman":this.requiredSalesman,
      "Txt":this.trueDemandOrderComment,
      "Vreg":this.requiredVReg,
      "isDelivery":this.supplierRequirements['delivery'],
      "userId":this.quote.userId

    },
    "lastcall": localStorage.getItem('lastcall'),
    "checkoutNow":true
  }

  
  
  // ----------------- Complete Order -----------------------------------------------------------
  if(this.getAvailableStock((this.trueDemandSupplierQuantities.get(line) ?? 0)) <= line.soh || 
  this.getAvailableStock((this.trueDemandSupplierQuantities.get(line) ?? 0)) != 0){
    this.showProcessing();
    this.searchService.PlaceOrder(Order).subscribe((res:any) =>
      {
        this.notification.ShowAlert({type: resultType.Success,
            title: "Order Placed",
            htmlMessage: 'Your Order has been Placed Successfully <br>' +
                        'Remember to Reload if order is not Visable',
            maskClosable: false,
            autoCloseInMilliseconds: 3000})
            .afterClose.subscribe(_=>{
              this.assignWIP(true);
            });
        
      },
      error =>
      {
        this.notification.handleError(error);
        this.isLoading = false;
      })
  }else{
    this.notification.showWarning(`Invalid order quantity`)
  }
  // ----------------- Complete Order [END] -----------------------------------------------------------
}
replenishmentCheckout(line: QuoteLine): void {
  
  var Order = {
    "OrderDetails":[
      {
        "brand": line.brand,
        "code": line.stockCode,
        "description": line.description,
        "id": "id"+line.stockCode,
        "image": line.brandLogoUrl,
        "mass": 0,
        "minOrder": 0,
        "minOrderFee": 0,
        "msfid":line.msfid,
        "price":line.price,
        // "qty": this.getReplenishmentQuantity(line),
        "qty": this.replenishmentQuantityByLine.get(line),
        "selectedIndex":1,
        "seller": line.replenishmentSupplierName,
        "sellerId": line.replenishmentSupplierId,
        "soh": line.soh,
        "sohInt": line.soh,
        "stockUsedId": null
      }
    ],
    "Settings":{
      "Delivery":"",
      "Extref":"",
      "Make":"",
      "Milage":"0",
      "Salesman":this.quote.userFullname,
      "Txt":"",
      "Vreg":"",
      "isDelivery":null,
      "userId":this.quote.userId

    },
    "lastcall": localStorage.getItem('lastcall'),
    "checkoutNow":false
  }
  // console.log(Order)
  if((this.replenishmentQuantityByLine.get(line) ?? 0) <= line.soh || 
  (this.replenishmentQuantityByLine.get(line) ?? 0) != 0){
    this.showProcessing();
    this.searchService.PlaceOrder(Order).subscribe((res:any) =>
      {
        this.notification.removeAlert();
        this.notification.ShowAlert({type: resultType.Success,
        title: "Item Added to Replenishment Order",
        htmlMessage: 'Your Order has been Placed Successfully <br>' +
                    'and added to your next replenishment delivery',
        maskClosable: false,
        autoCloseInMilliseconds: 3000})
        .afterClose.subscribe(_=>{
              this.assignWIP(true);
        });
       
      },
      error =>
      {
        this.notification.handleError(error);
        this.isLoading = false;
      })
  }else{
    this.notification.showWarning('Invalid order quantity');
  }
  

}
showProcessing()
{
  this.notification.ShowAlert({type: resultType.Information,
    title: "Placing Order",
    htmlMessage: 'Your Order is being placed <br>'+
                  ' It may take up to 30 secs to complete <br>'+
                  '<i nz-icon style="font-size:24px"  class="text" nzType="sync" nzTheme="outline"></i>' ,
    maskClosable: false,
    autoCloseInMilliseconds: 15000});
  return
}

demandAssignmentLoading = false;
enoughSOH = true;
startDemandAssignment(){
  for (let x = 0; x < this.quote.lines.length; x++) {
    if (this.quote.lines[x].stockTypeId == 1) {
      if(this.quote.lines[x].qty > this.quote.lines[x].soh){
        this.enoughSOH = false;
      }
      if(this.quote.lines[x].clientId != this.quote.clientId){
        this.enoughSOH = false;
      }
    }
  }
  if(this.authService.user.hasTrueDemand && !this.enoughSOH){
    this.initializeReplenishmentTypes();
    this.findPotentialSuppliersOnStockCode();
    this.isOrderTypeModalVisible = true;
  }else{
    this.assignWIP(true);
  }
 
}
}

type ReplenishmentType = 'replenishment' | 'trueDemand';

